export default __webpack_public_path__ + "static/media/ig1.734e746f.jpg";